import utils from './common';

const hasTodayProgress = (dailyMap) => {
  const today = utils.getDateFromNow().replace(/-/g, '');
  return dailyMap.meta.progress[today] !== undefined;
};

export default { hasTodayProgress };
